import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import {
  cardStyles,
  diffStyle,
  logoContainerStyle,
  logoStyle,
  progressStyle,
  textContainerStyle,
  timeStyle,
  titleStyle,
} from "./style";
import CartIcon from "components/icons/svgs/cart.svg";
import MarkIcon from "components/icons/svgs/mark.svg";

import PendingTaskIcon from "components/icons/svgs/pending-task.svg";
import AppComletionIcon from "components/icons/svgs/app-completion.svg";
import WorkbookComletionIcon from "components/icons/svgs/workbook-completion.svg";
import TeacherChangeRateIcon from "components/icons/svgs/teacher-change-rate.svg";
import TeacherEfficiencyIcon from "components/icons/svgs/teacher-efficiency.svg";

import InfoIcon, { TooltipIconColor, TooltipType } from "components/InfoIcon";
import makeStyles from "pages/style";
import theme from "assets/theme";
import { Tooltip } from "@mui/material";

function Card({
  title,
  progress,
  logoBg,
  logo,
  diff,
  time,
  isPercent,
  information,
  customCardClasses,
}) {
  const classes = makeStyles();
  const {
    customCarWrapperStyle,
    customTitleStyle,
    customMainValueStyle,
    customPercentStyle,
    customIconStyle,
    customTimeStyle,
    customLogoContainerStyle,
    customLogoStyle,
    customTextWrapperStyle,
  } = customCardClasses(theme);

  const getIcon = (logo) => {
    switch (logo) {
      case "cart":
        return CartIcon;
      case "mark":
        return MarkIcon;
      case "pending-task":
        return PendingTaskIcon;
      case "app-completion":
        return AppComletionIcon;
      case "workbook-completion":
        return WorkbookComletionIcon;
      case "teacher-change-rate":
        return TeacherChangeRateIcon;
      case "teacher-efficiency":
        return TeacherEfficiencyIcon;
      default:
        return MarkIcon;
    }
  };

  return (
    <MDBox
      display="flex"
      position={"relative"}
      flexDirection="column"
      justifyContent="space-between"
      sx={(theme) => ({
        ...cardStyles(theme),
        ...(customCarWrapperStyle && customCarWrapperStyle),
      })}
    >
      <Tooltip title={information}>
        <MDBox
          display="flex"
          justifyContent="space-between"
          height="100%"
          position="relative"
        >
          <MDBox
            sx={(theme) => ({
              ...textContainerStyle(theme),
              ...(customTextWrapperStyle && customTextWrapperStyle),
            })}
          >
            <MDTypography
              fontWeight="bold"
              sx={(theme) => ({
                ...titleStyle(theme),
                ...(customTitleStyle && customTitleStyle),
              })}
            >
              {title}
            </MDTypography>
            <MDTypography
              fontWeight="bold"
              lineHeight="100%"
              sx={(theme) => ({
                ...progressStyle(theme),
                ...(customMainValueStyle && customMainValueStyle),
              })}
            >
              {+Number(progress).toFixed(2) + ""}
              {isPercent ? "%" : ""}
            </MDTypography>
            {time && (
              <MDBox display="flex" gap={1} alignItems="center">
                {isPercent && (
                  <MDTypography
                    sx={(theme) => ({
                      ...diffStyle(theme, { diff }),
                      ...(customPercentStyle && customPercentStyle),
                    })}
                  >
                    {" "}
                    {/* customPercentStyle */}
                    {+Number(diff).toFixed(2) + ""}
                    {isPercent ? "%" : ""}
                  </MDTypography>
                )}
                <MDTypography
                  className="time"
                  sx={(theme) => ({
                    ...timeStyle(theme),
                    ...(customTimeStyle && customTimeStyle),
                  })}
                >
                  {time}
                </MDTypography>
              </MDBox>
            )}
          </MDBox>
          <InfoIcon
            type={TooltipType.CARD}
            content={information}
            color={TooltipIconColor.BLUE}
            className={classes.containerInfoIconCard}
            sx={() => ({
              ...(customIconStyle && customIconStyle),
            })}
          />
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={(theme) => ({
              ...logoContainerStyle(theme, { logoBg }),
              ...(customLogoContainerStyle && customLogoContainerStyle),
            })}
          >
            <MDBox
              component="img"
              src={getIcon(logo)}
              sx={(theme) => ({
                ...logoStyle(theme),
                ...(customLogoStyle && customLogoStyle),
              })}
            />
          </MDBox>
        </MDBox>
      </Tooltip>
    </MDBox>
  );
}
Card.defaultProps = {
  title: "",
  progress: 0,
  logoBg: "white",
  logo: () => <></>,
  time: "",
  isPercent: false,
  information: "",
};
Card.propTypes = {
  title: PropTypes.string,
  progress: PropTypes.number,
  logoBg: PropTypes.string,
  logo: PropTypes.node,
  diff: PropTypes.number,
  time: PropTypes.string,
  isPercent: PropTypes.bool,
  information: PropTypes.string,
};
export default Card;
